import { render, staticRenderFns } from "./InventoryPrintTag.vue?vue&type=template&id=21dc7662&scoped=true&"
import script from "./InventoryPrintTag.vue?vue&type=script&lang=js&"
export * from "./InventoryPrintTag.vue?vue&type=script&lang=js&"
import style0 from "./InventoryPrintTag.vue?vue&type=style&index=0&id=21dc7662&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dc7662",
  null
  
)

export default component.exports